import modelExtend from 'dva-model-extend'
import { basicModel, UPDATESTATE } from '@sisyphe/utils'

export default modelExtend(basicModel, {
  namespace: 'session',
  state: {
    userInfo: {},
  },
  reducers: {},
  effects: {
    /** 设置用户信息 */
    *setUserInfo({ payload }, { call, put }) {
      yield put({
        type: UPDATESTATE,
        payload: { userInfo: payload },
      })
    },
  },
})
